// extracted by mini-css-extract-plugin
module.exports = {"Row":"src_Row__zPimy","Column":"src_Column__FJOhS","DoubleColumn":"src_DoubleColumn__3oulj","TripleColumn":"src_TripleColumn__4Ds4b"};